import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Index from "./pages/Index";
import OurStory from "./pages/OurStory";
import TeamPage from "./pages/TeamPage";
import AttorneyBioPage from "./pages/AttorneyBioPage";
import ServicesPage from "./pages/ServicesPage";
import NewsPage from "./pages/NewsPage";
import ArticlePage from "./pages/ArticlePage";
import JoinUsPage from "./pages/JoinUsPage";
import LocationsPage from "./pages/LocationsPage";
import NewsletterSignupPage from "./pages/NewsletterSignupPage";
import PrivacyDisclaimerPage from "./pages/PrivacyDisclaimerPage";
import SiteMapPage from "./pages/SiteMapPage";
import DiversityPage from "./pages/DiversityPage";
import IntakePage from "./pages/IntakePage";
import ArchivedArticlesPage from "./pages/ArchivedArticlesPage";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/team/:slug" element={<AttorneyBioPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<ArticlePage />} />
          <Route path="/join-us" element={<JoinUsPage />} />
          <Route path="/locations" element={<LocationsPage />} />
          <Route path="/newsletter" element={<NewsletterSignupPage />} />
          <Route path="/privacy" element={<PrivacyDisclaimerPage />} />
          <Route path="/disclaimer" element={<PrivacyDisclaimerPage />} />
          <Route path="/sitemap" element={<SiteMapPage />} />
          <Route path="/diversity" element={<DiversityPage />} />
          <Route path="/intake" element={<IntakePage />} />
          <Route path="/archived-articles" element={<ArchivedArticlesPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
